import styled from "styled-components";

import Theme from "./../../styles/Theme";

export const ServicesWrapper = styled.section`
  background: ${Theme.color.mainBlack};
`;

export const ServicesContainer = styled.div`
  color: ${Theme.color.mainWhite};
`;

export const ServiceContainer = styled.div``;
